// index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import '@huoncroll/math-editors/dist/index.css';
import App from './App.tsx';
import reportWebVitals from './reportWebVitals';
import { ThemeProvider, createTheme, CssBaseline } from '@mui/material';

const theme = createTheme({
  palette: {
    background: {
      // Off-white page backdrop so white cards and surfaces read against it.
      default: 'rgb(255, 255, 254)',
    },
  },
  typography: {
    // Disable MUI's default all-caps button text.
    button: {
      textTransform: 'none',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        // Slightly thicken outlined button borders globally.
        outlined: {
          borderWidth: '2px',
        },
      },
    },
    MuiDivider: {
      styleOverrides: {
        root: {
          borderBottomWidth: 2,
        },
        vertical: {
          borderBottomWidth: 0,
          borderRightWidth: 2,
        },
      },
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <App />
    </ThemeProvider>
  </React.StrictMode>
);

reportWebVitals();
